/* ============================================================
   PENS PERSONALISED — ENGRAVING TEXT FIT (v5, 05/10/2026)
   File: assets/pp-engrave-fit.js   (loaded site-wide, deferred)

   ONE mechanism for every pen preview and every screen size.

   LINE 1 / LINE 2
   - Line 1 is the original engraving box (20 characters).
   - Line 2 is an optional second box (20 characters) added under
     Line 1. When it has text, Line 1 lifts slightly and Line 2 sits
     centred beneath it as a twin element.
   - At add-to-cart the two lines are sent as one Engraving value
     "Line one / Line two".

   SIZING (the rule that keeps text ON the pen)
   1. Measure each line in the chosen typeface (canvas).
   2. Fit into the element's own width (the barrel zone), at most
      92% of it; short names are capped so they don't balloon.
   3. There is NO practical minimum: v4 had an 8px floor, so on a
      phone a 20-letter name stopped shrinking and ran off the
      barrel. The floor is now 3px, i.e. width always wins.
   4. After rendering, the real width is checked; if the text is
      still wider than its zone (font not loaded yet, odd glyphs),
      it is scaled down to fit. Text can never leave the zone.
   ============================================================ */
(function () {
  'use strict';

  var SEL = '.pen-personaliser__engrave-text';
  var CAP_RATIO = 0.10;
  var FILL = 0.92;
  var MIN_PX = 3;
  var PER_LINE = 20;
  var SEP = ' / ';
  var LIFT = 0.58;            /* each line moves this many em from centre */
  var FACES = [
    { test: /corsiva/i, scale: 0.94 },
    { test: /dancing/i, scale: 0.96 }
  ];

  var ctx = null;
  function context() {
    if (ctx) return ctx;
    var c = document.createElement('canvas');
    ctx = c.getContext('2d');
    return ctx;
  }
  function faceScale(family) {
    for (var i = 0; i < FACES.length; i++) {
      if (FACES[i].test.test(family)) return FACES[i].scale;
    }
    return 1;
  }
  function sizeFor(text, zone, family) {
    var c = context();
    var perPx = 1;
    if (c) {
      c.font = '100px ' + family;
      perPx = (c.measureText(text).width || 100) / 100 + 0.02 * text.length;
    }
    var size = Math.min(zone * CAP_RATIO, (zone * FILL) / perPx) * faceScale(family);
    return Math.max(MIN_PX, size);
  }

  /* Rendered width of the text itself (not the element box) */
  function inkWidth(el) {
    try {
      var r = document.createRange();
      r.selectNodeContents(el);
      return r.getBoundingClientRect().width / (scaleOf(el) || 1);
    } catch (e) { return 0; }
  }
  /* The preview scene can be CSS-scaled (zoomed photo); compare in
     the element's own, unscaled pixels. */
  function scaleOf(el) {
    var w = el.getBoundingClientRect().width;
    return el.offsetWidth ? w / el.offsetWidth : 1;
  }

  /* ── Elements for a given section ── */
  function suffixOf(el) { return el.id.replace(/^engraveText-/, ''); }
  function line2Input(suffix) { return document.getElementById('engraveLine2-' + suffix); }
  function line1Input(suffix) { return document.getElementById('engraveInput-' + suffix); }
  function twin(el) {
    var id = 'engraveText2-' + suffixOf(el);
    var t = document.getElementById(id);
    if (!t) {
      t = document.createElement('div');
      t.id = id;
      t.setAttribute('aria-hidden', 'true');
      el.insertAdjacentElement('afterend', t);
    }
    return t;
  }

  function setStyle(el, prop, val) {
    if (el.style.getPropertyValue(prop) !== val) el.style.setProperty(prop, val, 'important');
  }

  function fit(el) {
    if (!el || !el.isConnected || !el.id) return;
    var suffix = suffixOf(el);
    var in2 = line2Input(suffix);
    var l2 = in2 ? in2.value.trim() : '';
    var t = document.getElementById('engraveText2-' + suffix);

    var zone = el.clientWidth;
    if (!zone) return;
    var family = window.getComputedStyle(el).fontFamily || 'serif';
    /* Placeholder on the pen reads "Your text" (sections write "Your name") */
    if ((el.textContent || '').trim() === 'Your name') el.textContent = 'Your text';
    var l1 = (el.textContent || '').trim() || 'Your text';

    var size = sizeFor(l1, zone, family);
    if (l2) size = Math.min(size, sizeFor(l2, zone, family));
    setStyle(el, 'font-size', size.toFixed(2) + 'px');

    /* Safety net: measure what actually rendered and shrink to fit */
    var ink = inkWidth(el);
    var limit = zone * 0.96;
    if (ink > limit) {
      size = Math.max(MIN_PX, size * limit / ink);
      setStyle(el, 'font-size', size.toFixed(2) + 'px');
    }

    if (!l2) {
      if (el.style.getPropertyValue('transform')) el.style.removeProperty('transform');
      if (t) t.hidden = true;
      return;
    }

    /* Two lines: lift line 1, twin beneath with identical styling */
    setStyle(el, 'transform', 'translate(-50%, calc(-50% - ' + LIFT + 'em))');
    t = twin(el);
    t.hidden = false;
    var cls = el.className;
    if (t.className !== cls) t.className = cls;
    if (t.textContent !== l2) {
      t.textContent = l2;
      t.classList.remove('pen-personaliser__sweep');
      void t.offsetWidth;
      t.classList.add('pen-personaliser__sweep');
    }
    var css = el.style.cssText;
    if (t.dataset.css !== css) {
      t.style.cssText = css;
      t.style.setProperty('transform', 'translate(-50%, calc(-50% + ' + LIFT + 'em))', 'important');
      t.dataset.css = css;
    }
    /* Line 2 safety net, same rule */
    var ink2 = inkWidth(t);
    if (ink2 > limit) {
      var s2 = Math.max(MIN_PX, size * limit / ink2);
      setStyle(el, 'font-size', s2.toFixed(2) + 'px');
      t.style.setProperty('font-size', s2.toFixed(2) + 'px', 'important');
      t.dataset.css = el.style.cssText;
    }
  }

  function fitAll() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].id && nodes[i].id.indexOf('engraveText2-') === 0) continue;
      fit(nodes[i]);
    }
  }

  var pending = null;
  function schedule(delay) {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () {
      pending = null;
      fitAll();
    }, delay == null ? 30 : delay);
  }

  /* ── Line 2 box, added under the Line 1 box ── */
  function addLine2(in1) {
    var suffix = in1.id.replace('engraveInput-', '');
    if (line2Input(suffix)) return;
    var group = in1.closest('.pen-personaliser__field-group');
    if (!group) return;

    group.classList.add('pp-line1-group');
    in1.setAttribute('placeholder', 'e.g. David');
    var lab = group.querySelector('label[for="' + in1.id + '"]');
    if (lab) lab.textContent = 'Line 1';

    var g2 = document.createElement('div');
    g2.className = 'pen-personaliser__field-group pp-line2-group';
    g2.innerHTML =
      '<label class="pen-personaliser__field-label" for="engraveLine2-' + suffix + '">' +
      'Line 2 <span style="font-weight:400;opacity:.7">(optional)</span></label>' +
      '<input type="text" id="engraveLine2-' + suffix + '" maxlength="' + PER_LINE + '" placeholder="e.g. Love from Sarah" value="" autocomplete="off">' +
      '<div class="pen-personaliser__count-row"><span></span><span id="charCount2-' + suffix + '">0 / ' + PER_LINE + '</span></div>';
    group.insertAdjacentElement('afterend', g2);

    var in2 = line2Input(suffix);
    if (in1.className) in2.className = in1.className.replace(/\bhas-error\b/, '').trim();
    in2.addEventListener('input', function () {
      document.getElementById('charCount2-' + suffix).textContent = in2.value.length + ' / ' + PER_LINE;
      schedule(0);
    });
  }

  /* ── Layout tidy (once per personaliser) ── */
  function tidyLayout(in1) {
    if (!document.getElementById('ppLineStyles')) {
      var st = document.createElement('style');
      st.id = 'ppLineStyles';
      st.textContent =
        '.pen-personaliser__count-row > span:last-child{margin-left:auto;}' +
        '.pp-moved-under-cta.pp-trust-box{margin-top:16px;}' +
        '.pp-moved-under-cta.pp-logo-line{margin-top:10px;}' +
        '.pen-personaliser__form-col .pen-personaliser__field-group{margin-bottom:12px !important;}' +
        '.pen-personaliser__form-col .pen-personaliser__field-label{margin-bottom:5px !important;}' +
        '.pen-personaliser__form-col .pen-personaliser__count-row{margin-top:3px !important;}' +
        '.pen-personaliser__form-col .pp-line1-group{margin-bottom:0 !important;}' +
        '.pen-personaliser__form-col .pp-line1-group .pen-personaliser__count-row{margin-top:2px !important;line-height:1.2;}' +
        '.pen-personaliser__form-col .pp-line2-group .pen-personaliser__field-label{margin-bottom:3px !important;line-height:1.2;}' +
        '@media (max-width:900px){' +
          '.pen-personaliser__form-col{padding-top:4px !important;}' +
          '.pen-personaliser__caption{margin:8px 0 0 !important;}' +
        '}';
      document.head.appendChild(st);
    }
    var panel = in1.closest('.pen-personaliser__panel');
    if (!panel || panel.dataset.ppTidy) return;
    panel.dataset.ppTidy = '1';
    var anchor = panel.querySelector('.pen-personaliser__confirm') || panel.querySelector('.pen-personaliser__cta-row');
    if (!anchor) return;
    var trust = panel.querySelector('.pp-trust-box');
    var logo = panel.querySelector('.pp-logo-line');
    if (logo) { logo.classList.add('pp-moved-under-cta'); anchor.insertAdjacentElement('afterend', logo); }
    if (trust) { trust.classList.add('pp-moved-under-cta'); anchor.insertAdjacentElement('afterend', trust); }
  }

  /* Prefill or old values may arrive as "Line one / Line two" */
  function splitInto(in1) {
    var v = in1.value;
    var at = v.indexOf(SEP);
    if (at === -1) return;
    var suffix = in1.id.replace('engraveInput-', '');
    var in2 = line2Input(suffix);
    if (!in2) return;
    in1.value = v.slice(0, at).trim().slice(0, PER_LINE);
    in2.value = v.slice(at + SEP.length).trim().slice(0, PER_LINE);
    in2.dispatchEvent(new Event('input', { bubbles: true }));
  }

  var watched = new WeakSet();
  function watch(el) {
    if (!el || watched.has(el)) return;
    watched.add(el);
    var mo = new MutationObserver(function () { schedule(0); });
    mo.observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    if (window.ResizeObserver) {
      var stage = el.closest('.pen-personaliser__stage') || el.parentNode;
      if (stage) new ResizeObserver(function () { schedule(0); }).observe(stage);
    }
    fit(el);
  }

  function watchAll() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].id && nodes[i].id.indexOf('engraveText2-') === 0) continue;
      watch(nodes[i]);
    }
    var ins = document.querySelectorAll('input[id^="engraveInput-"]');
    for (var j = 0; j < ins.length; j++) { addLine2(ins[j]); tidyLayout(ins[j]); }
  }

  window.PPEngraveFit = { fit: fitAll, watch: watchAll };

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.id && t.id.indexOf('engraveInput-') === 0) {
      if (t.value.indexOf(SEP) !== -1) splitInto(t);
      schedule(0);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing) return;
    var t = e.target;
    if (!t || !t.id) return;
    if (t.id.indexOf('engraveInput-') === 0) {
      e.preventDefault();
      var in2 = line2Input(t.id.replace('engraveInput-', ''));
      if (in2) in2.focus();
    } else if (t.id.indexOf('engraveLine2-') === 0) {
      e.preventDefault();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.id || f.id.indexOf('penPersonaliserForm-') !== 0) return;
    var suffix = f.id.replace('penPersonaliserForm-', '');
    var in1 = line1Input(suffix), in2 = line2Input(suffix);
    if (!in1 || !in2) return;
    var a = in1.value.trim(), b = in2.value.trim();
    if (!a || !b) return;
    f.dataset.ppLine1 = in1.value;
    in1.value = a + SEP + b;
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.dataset || f.dataset.ppLine1 == null) return;
    var in1 = line1Input(f.id.replace('penPersonaliserForm-', ''));
    if (in1) in1.value = f.dataset.ppLine1;
    delete f.dataset.ppLine1;
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.pp-font-pill') || e.target.closest('.pp-home-font') || e.target.closest('[id^="ppTrigger-"]') || e.target.closest('#ppStickyBtn')) {
      schedule(60);
    }
  });
  window.addEventListener('pp:open-modal', function () { watchAll(); schedule(80); schedule(320); });
  window.addEventListener('resize', function () { schedule(100); });
  window.addEventListener('orientationchange', function () { schedule(250); });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { schedule(0); });
    document.fonts.addEventListener && document.fonts.addEventListener('loadingdone', function () { schedule(0); });
  }

  function init() { watchAll(); schedule(0); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
